function formatCardNumber(value) {
  return value ? value.match(/.{1,4}/g).join(' ') : ''
}

export { formatCardNumber }
